import React from 'react';
import validator from 'validator';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { firebaseConnect } from 'react-redux-firebase';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { routerActions } from 'react-router-redux';
import { FormattedMessage, defineMessages, intlShape } from 'react-intl';

import * as UI from '../components';
import { userIsNotAuthenticated } from '../behaviors';

const messages = defineMessages({
  header: {
    id: 'log-in.header',
    defaultMessage: 'Log-in to get your tokens before they sell out...',
  },
  emailPlaceholder: {
    id: 'log-in.email.placeholder',
    defaultMessage: 'E-mail Address',
  },
  passwordPlaceholder: {
    id: 'log-in.password.placeholder',
    defaultMessage: 'Password',
  },
  submit: { id: 'log-in.submit', defaultMessage: 'Log In' },
  noAccount: {
    id: 'log-in.no-account-message',
    defaultMessage: "Don't have an account yet?",
  },
  signUp: {
    id: 'log-in.sign-up-message',
    defaultMessage: 'Click here to sign up!',
  },
  referralCode: { id: 'log-in.referral-code', defaultMessage: 'Referral Code' },
})

class Login extends React.Component {
  render() {
    const {
      handleSubmit,
      login,
      error,
      submitFailed,
      submitting,
      pristine,
      invalid,
      storefront,
    } = this.props

    const { intl } = this.context

    return (
      <UI.Form onSubmit={handleSubmit(login)}>
        <UI.Card image={storefront.iconUrl}>
          <UI.Divider hidden />

          <UI.Text center size="huge" weight="bold" color="primary">
            <FormattedMessage {...messages.header} />
          </UI.Text>

          <UI.Divider hidden />

          {submitFailed && <UI.Message type="error">{error}</UI.Message>}

          <UI.Divider hidden />

          <Field
            fluid
            icon="user"
            iconPosition="left"
            placeholder={intl.formatMessage(messages.emailPlaceholder)}
            name="email"
            component={UI.TextField}
          />

          <Field
            fluid
            icon="lock"
            iconPosition="left"
            placeholder={intl.formatMessage(messages.passwordPlaceholder)}
            name="password"
            type="password"
            component={UI.TextField}
          />

          <UI.Button disabled={pristine || invalid || submitting}>
            <FormattedMessage {...messages.submit} />
          </UI.Button>
        </UI.Card>

        <UI.Text center size="small">
          <FormattedMessage {...messages.noAccount} />

          <UI.Link to="/signup">
            &nbsp; <FormattedMessage {...messages.signUp} />
          </UI.Link>
        </UI.Text>

        <UI.PoweredBy />
      </UI.Form>
    )
  }
}

Login.contextTypes = {
  intl: intlShape,
}

const selectors = createStructuredSelector({
  initialValues: () => ({
    email: '',
    password: '',
  }),
})

const actions = (dispatch, props) => ({
  login: async ({ email, password }) => {
    try {
      await props.firebase.login({ email, password });
      dispatch(routerActions.push('/'));
      dispatch({ type: 'LOGIN', track: { email } })
    } catch (error) {
      throw new SubmissionError({ _error: error.message })
    }
  },
})

const validate = values => {
  const errors = {}

  if (validator.isEmpty(values.email))
    errors.email = 'E-mail address is required'
  if (validator.isEmpty(values.password))
    errors.password = 'Password is required'

  return errors
}

export default compose(
  firebaseConnect(),
  connect(selectors, actions),
  reduxForm({ form: 'Login', validate }),
  userIsNotAuthenticated()
)(Login)



// WEBPACK FOOTER //
// ./src/screens/Login.js